import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { StatutEmploiModel } from '../../models/StatutEmploiModel';
import { CacheService } from '../../services/cache-service';
import { ConfigurationService } from '../../services/configuration.service';
import { GuidService } from '../../services/guid.service';

@Component({
  selector: 'app-statut-emploi-dropdown',
  templateUrl: './statut-emploi-dropdown.component.html',
  styleUrl: './statut-emploi-dropdown.component.css',
  viewProviders: [
    {
      provide: ControlContainer,
      deps: [[Optional, NgForm]],
      useFactory: (ngForm: NgForm) => ngForm
    }
  ]
})
export class StatutEmploiDropdownComponent implements OnInit {
  @Input() editMode: boolean = true;
  @Input() showClear: boolean = false;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() placeholder: string = ''; // Sélectionner un taux de TVA
  pDropdownStyle: any = {};
  minWidth: string = '84px';

  private _statutId: number;
  @Input()
  set statutId(value: number) {
    this._statutId = value;
    this.selectStatut();
  }
  get statutId(): number {
    return this._statutId;
  }

  _statut: StatutEmploiModel = null;
  @Input()
  set statut(value: StatutEmploiModel) {
    this._statut = value;
    this._statutId = value?.Id;
  }
  get statut(): StatutEmploiModel {
    return this._statut ? this._statut : null;
  }

  @Input() inputFocus: string;
  @Input() inputFocusValue: string;

  @Output() statutIdChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() statutChange: EventEmitter<StatutEmploiModel> = new EventEmitter<StatutEmploiModel>();
  @Output() inputFocusChange: EventEmitter<string> = new EventEmitter<string>();

  public statuts: StatutEmploiModel[] = [];
  public guid: string;
  public statutsLoaded: boolean = false;

  constructor(
    configurationService: ConfigurationService,
    private guidService: GuidService,
    private cacheService: CacheService
  ) {
    this.pDropdownStyle = { ...configurationService.pDropdownStyle, 'min-width': this.minWidth };
  }

  ngOnInit() {
    this.guid = this.guidService.newGuid();
    if (!this.statutsLoaded) {
      this.loadStatuts();
    } else {
      this.selectStatut();
    }
  }

  selectStatut() {
    if (this.statutsLoaded) {
      setTimeout(() => {
        this.statut = this.statuts.find((t) => this._statutId != null && this._statutId != undefined && t.Id == this._statutId);
      });
    }
  }

  loadStatuts() {
    this.cacheService.getStatutEmplois().subscribe((statuts) => {
      this.statuts = statuts;
      this.statutsLoaded = true;
      this.selectStatut();
    });
  }

  inputFocusChanged(value) {
    this.inputFocus = value;
    this.inputFocusChange.emit(this.inputFocus);
  }

  statutChanged() {
    if (this.statutsLoaded) {
      if (this._statutId != this._statut?.Id) {
        this._statutId = this._statut?.Id;
        this.statutIdChange.emit(this._statutId);
        this.statutChange.emit(this._statut);
      }
    }
  }
}
